/* eslint-disable no-underscore-dangle */
import { pick } from 'lodash';
import { compose, withProps, mapProps } from 'recompose';

// allows namespacing a set of higher order components
// helps to avoid props naming collision and unneeded props to be passed out of component
// reveal(['propName1', 'propName2'], hoc1, hoc2, hocN);
const reveal = (propsToReveal, ...hocs) => compose(
  withProps(props => ({ _parentProps: props })),
  ...hocs,
  mapProps(props => ({ ...pick(props, propsToReveal), ...props._parentProps })),
);

export default reveal;
